<template>
  <div class="">
    <div class="search-box">
      <div class="search-item">
        <label>账号名：</label>
        <a-input placeholder="请输入" v-model.trim="searchTerm.alias" />
      </div>
      <div class="search-item">
        <label>手机号：</label>
        <a-input placeholder="请输入"  v-model.trim="searchTerm.account"  />
      </div>
      <div class="search-btn" style="display: inline-block;">
        <a-button type="primary" @click="search">查询</a-button>
        <a-button  @click="reset">重置</a-button>
      </div>
    </div>
    <a-table 
      :locale="{
        emptyText: '暂无数据'
      }"
      :columns="columns" 
      @change="handleTableChange" 
      :pagination="pagination"  
      rowKey="id"  
      :data-source="data"  
      style="margin-top: 12px;"
    >
      <span @mouseenter="changeActive($event)" @mouseleave="removeActive($event)"  slot="prepaidAccountBalance" slot-scope="text,record">{{text}} 
        <a-icon type="edit" style="cursor: pointer;"  @click="showEdit(record.id,text)" class="edit-show"/>
      </span>
      <span @click="openModal(1,record.id)"  slot="frozenAmount" slot-scope="text,record"><a>{{text}}</a></span> 
      <span @click="openModal(2,record.id)"  slot="accountCost" slot-scope="text,record"><a>{{text}}</a></span> 
      <span slot="prepaidAccountBalance">账户余额(元)
        <a-tooltip placement="bottom"
            :getPopupContainer="
            triggerNode => {
              return triggerNode.parentNode || document.body;
            }
          ">
          <span slot="title">供应商账户中的剩余金额</span>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </span>
      <span slot="frozenAmount">冻结资金(元)
        <a-tooltip placement="bottom"
              :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }
            ">
          <span slot="title">交易未完成的订单总额</span>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </span>
      <span slot="accountCost">已用资金(元)
        <a-tooltip placement="bottom"
              :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }
            ">
          <span slot="title">交易完成的订单总额</span>
          <a-icon type="exclamation-circle" />
        </a-tooltip>
      </span>
    </a-table>
    <a-modal v-model="visible" title="编辑账户余额" >
      <template slot="footer">
          <a-button key="submit" type="primary"  @click="handleSubmit">
          确定
          </a-button>
          <a-button key="back"   @click="handleCancel">
          取消
          </a-button>
      </template>
      <div class="edit-box">
        <a-row class="item">
          <a-col :span="5"><label >当前账户余额：</label></a-col>
          <a-col :span="17"><span>￥{{balance.fund}}</span></a-col>
        </a-row>
        <a-row class="item account">
          <a-col :span="5"><label >充值金额：</label></a-col>
          <a-col :span="17"><a-input v-model="balance.depositAmount" allowClear placeholder="请输入"></a-input></a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
import page from "@/assets/mixin/page.js";
const columns = [
  {
    title: '账号名',
    dataIndex: 'alias',
    key: 'alias',
    ellipsis:true,
  },
  {
    title: '手机号',
    dataIndex: 'account',
    key: 'account',
  },
  {
    // title: '账户余额(元)',
    dataIndex: 'prepaidAccountBalance',
    key: 'prepaidAccountBalance',
    slots: { title: 'prepaidAccountBalance' },
    scopedSlots: { customRender: 'prepaidAccountBalance' },
    align:"right",
  },
  {
    // title: '冻结资金(元)',
    dataIndex: 'frozenAmount',
    key: 'frozenAmount',
    slots: { title: 'frozenAmount' },
    scopedSlots: { customRender: 'frozenAmount' },
    align:"right",
  },
  {
    // title: '已用资金(元)',
    key: 'accountCost',
    dataIndex: 'accountCost',
    slots: { title: 'accountCost' },
    scopedSlots: { customRender: 'accountCost' },
    align:"right",
  },
  {//占位
    dataIndex: 'accountCost1',
  },
];

export default {
  name:"channel-account",
  mixins: [page],
  data() {
    return {
      data:[],
      columns,
      balance:{
        depositAmount:''
      },
      visible:false,
    };
  },
  created(){
    this.getdata()
  },
  methods:{
    showEdit(supplierId,fund){
      this.balance = {
        supplierId:supplierId,
        fund:fund,
        depositAmount:'',
      };
      this.visible = true;
    },
    handleSubmit(){
      if (this.check()) {
        let {fund,...params} = this.balance;
        this.$http.post('supplyCost/depositPrepaidAccount','',{params}).then(res=>{
          if (res.result) {
            this.$message.success('充值成功')
            this.handleCancel();
            this.getdata();
          } else {
            this.$message.warning(res.message)
          }
        })
      }else{
        this.$message.warning("请输入合法数字");
      }
    },
    handleCancel(){
      this.visible = false;
      // this.balance = {};
    },
    check(){
      const value = this.balance.depositAmount;
      const reg = /^-?[0-9]*(\.[0-9]*)?$/;
      if (!((!isNaN(value) && reg.test(value)) || value === '' || value === '-')) {
        return false
      }
      return true
    },
    changeActive($event) {
      $event.currentTarget.className = 'active';
    },
    removeActive($event) {
      $event.currentTarget.className = '';
    },
    reset(){
      this.pagination.current = 1;
      this.searchTerm = {};
      this.getdata();
    },
    search(){
      this.pagination.current = 1;
      this.getdata();
    },
    getdata(){
      let params = {...this.searchTerm}
      params.nature = 1;
      params.pageNum = this.pagination.current;
      this.$http.post('supplyCost/queryRecordList',params).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;
      })
    },
    openModal(index,account){
      if (index==1) {
        this.$router.push({name:'supplier-advance',query:{id:account,title:"冻结资金"}})
      } else if(index==2) {
        this.$router.push({name:'supplier-advance',query:{id:account,title:"已用资金"}})
      }
    },
  }
};
</script>
<style lang="less" scoped>
.edit-box{
  /deep/.item {
    margin-bottom: 16px;
    .ant-col-5{
      text-align: right;
    }
    label{
      color: rgba(0, 0, 0, 0.85)!important;
    } 
    .account{
      vertical-align: middle;
    }
  }
}
.table-header{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  span{
    font-size:16px;
    font-weight:400;
    color:rgba(0,0,0,0.85);
  }
}
.row-edit{
  display: inline-block;
  margin-right: 24px;
}
.active {
  .edit-show{
    visibility:visible;
  }
  }
  .edit-show{
    visibility:hidden;
  }
</style>
